import MainLayout from '@/common/components/layouts/MainLayout';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { OwnerStepsData } from '@/modules/adjusterReportModules/IncidentParticipants/data/ownerStepsData';
import { PropsWithChildren } from 'react';

import { useSearchParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  const [searchParams] = useSearchParams();
  return (
    <MainLayout
      title={`${searchParams.get('type') ? (searchParams.get('type') === 'culprit' ? 'مقصر' : 'زیان‌دیده') : 'زیان‌دیده'} / مالک`}
      header="closeHeader"
      hasBottomPadding
    >
      <OwnerInfo>{children}</OwnerInfo>
    </MainLayout>
  );
};
const OwnerInfo = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={OwnerStepsData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">{children}</Box>
    </>
  );
};
